const dprDataFormat = {
  _id: "",
  dprNo: "",
  project: {
    _id: "",
    title: "",
  },
  dprDate: "",
  status: "",
  version: "",
  createdBy: {
    _id: "",
    callingName: "",
    firstName: "",
    lastName: "",
  },
  updatedBy: null,
  createdAt: "",
  updatedAt: "",
};

export default dprDataFormat;
